import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { CimaCore, Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { AddonRouteType, AddonStatus, AddonType } from 'my-account/constants';

import { CmsAddonDetails, CmsDataDetail } from 'store/cms/models';
import { LineDetailsAddOnContent } from 'store/global-travel-pass/models/global-travel-pass';
import { XmCancelRemovalModal } from 'my-account/shared/modals/cancel-removal/cancel-removal';
import { MyAccountModal } from 'my-account/services/modal';
import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';

@Component({
    selector: 'xm-new-addons-detail',
    styleUrls: ['./new-addons-detail.scss'],
    templateUrl: './new-addons-detail.html',
    standalone: false
})
export class XmNewAddonsDetailComponent implements OnInit, OnDestroy {
    @Input() public addon: LineDetailsAddOnContent;

    public displayImage: MediaImageOptions;
    public inUseIcon: MediaImageOptions;
    public cmsAddonData: CmsAddonDetail;
    public pageData: CmsDataDetail;
    public title: string;
    public subheader: string;
    public subtitle: string;
    public statusBadge: string;
    public showBadge: boolean;
    public showBadgeWithoutIcon: boolean = false;
    public ctaLabel: string;
    public ctaDestination: string;
    public price: string;
    public isCBMInternationalReteLinkEnabled: boolean = false;

    private xmStore: XmStore;
    private state: StateService;
    private subscriptions: Subscription[] = [];
    private accountModal: MyAccountModal;
    private config: IXMOptions;
    private cimaCore: CimaCore;

    constructor(cimaCore: CimaCore, xmStore: XmStore, state: StateService, accountModal: MyAccountModal, @Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { cimaCore, xmStore, state, accountModal, config });
    }

    public ngOnInit(): void {
        this.isCBMInternationalReteLinkEnabled = this.config.ENABLE_CBM_INTERNATIONAL_RETE_LINK || !this.cimaCore.isBusinessUser;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.pageData = pageData;
            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(pageData.inUseIcon)
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsAddonDetails>(CmsAddonDetails), (pageData: CmsAddonDetails) => {

            this.cmsAddonData = pageData.details.find((detail: CmsAddonDetail) => detail.type === this.addon.type);
            this.displayImage = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsAddonData.icon)
            };
            this.processCmsContent();
        }));
    }

    public addOnFlow(): void {
        switch (true) {
            case this.addon.type === AddonType.GTP:
                if (this.addon.status === AddonStatus.ACTIVE) {
                    this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.GTP, intent: 'remove' });
                } else {
                    this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.GTP, intent: 'add' });
                }
                break;
            case this.addon.type === AddonType.CAN_MEX_UNL_PASS:
                if (this.addon.status === AddonStatus.ACTIVE) {
                    this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.MEX_CAN_PASS, intent: 'remove' });
                } else {
                    this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.MEX_CAN_PASS, intent: 'add' });
                }
                break;
        }
    }

    public cancelRemovalFlow(): void {
        this.accountModal.open(XmCancelRemovalModal, {
            lineId: this.addon.lineId,
            removalRequestCode: this.addon.removalRequestCode,
            isGtp: this.addon.type === AddonType.GTP
        });
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    private processCmsContent(): void {
        this.title = this.addon.headerContent;
        this.subtitle = this.addon.subtitleContent;
        this.subheader = this.addon.body;
        this.price = this.addon.price;
        this.ctaLabel = this.addon.cta?.content;
        this.ctaDestination = this.addon.cta?.destination;
        this.setBadgeContent();
    }

    private setBadgeContent(): void {
        switch (this.addon.status) {
            case AddonStatus.ACTIVE:
                this.showBadge = true;
                this.statusBadge = this.pageData.inUseBadge;
                break;
            case AddonStatus.INACTIVE:
                this.showBadgeWithoutIcon = true;
                this.statusBadge = this.pageData.offBadge;
                break;
            case AddonStatus.PENDING_REMOVAL:
                this.showBadge = true;
                this.ctaLabel = this.cmsAddonData.cancelRemovalCTA;
                this.statusBadge = this.pageData.pendingRemovalBadge;
                break;
            case AddonStatus.INCLUDED:
                this.showBadge = true;
                this.statusBadge = this.pageData.includedBadge;
        }
    }
}
